import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import HomeView from "../views/HomeView.vue";
import ProfileView from "@/views/ProfileView.vue";
import ForbiddenView from "@/views/ForbiddenView.vue";
import NotFound from "@/components/NotFound.vue";
import WaSesionsView from "@/views/WaSesionsView.vue";
import PenggunaView from "@/views/PenggunaView.vue";
import PresensiView from "@/views/PresensiView.vue";
import MesinView from "@/views/MesinView.vue";
import UserGuru from "@/components/UserGuru.vue";
import UserKaryawan from "@/components/UserKaryawan.vue";
import UserSiswa from "@/components/UserSiswa.vue";
import UserNonGtk from "@/components/UserNonGtk.vue";
import IzinView from "@/views/IzinView.vue";
import IzinGuru from "@/components/IzinGuru.vue";
import IzinKaryawan from "@/components/IzinKaryawan.vue";
import IzinSiswa from "@/components/IzinSiswa.vue";
import IzinNonGtk from "@/components/IzinNonGtk.vue";
import RiwayatGuru from "@/components/RiwayatGuru.vue";
import RiwayatKaryawan from "@/components/RiwayatKaryawan.vue";
import RiwayatSiswa from "@/components/RiwayatSiswa.vue";
import RiwayatNonGtk from "@/components/RiwayatNonGtk.vue";
import RekapPresensi from "@/components/RekapPresensi.vue";

const appTitle = process.env.VUE_APP_TITLE;

const routes = [
	{
		path: "/",
		name: "home",
		component: HomeView,
		meta: {
			type: "menu",
			icon: "bi bi-house-fill",
			menuTitle: "Beranda",
			page: {
				tab: appTitle,
				header: "Beranda",
				label: "Beranda",
			},
			allowedTypes: ["admin", "guru", "karyawan"],
			allowedRoles: ["dev", "presensi", "wa", "staf"],
		},
	},
	{
		path: "/wa",
		name: "wa",
		component: WaSesionsView,
		meta: {
			type: "menu",
			icon: "bi bi-whatsapp",
			menuTitle: "Sesi WhatsApp",
			page: {
				tab: `Sesi WhatsApp · ${appTitle}`,
				header: "Pengelolaan Sesi WhatsApp",
				label: "Sesi WhatsApp",
			},
			allowedTypes: ["admin", "guru", "karyawan"],
			allowedRoles: ["dev", "wa"],
		},
	},
	{
		path: "/mesin",
		name: "mesin",
		component: MesinView,
		meta: {
			type: "menu",
			icon: "bi bi-building-check",
			menuTitle: "Mesin Presensi",
			page: {
				tab: `Mesin Presensi · ${appTitle}`,
				header: "Pengelolaan Mesin Presensi",
				label: "Mesin Presensi",
			},
			allowedTypes: ["admin", "guru", "karyawan"],
			allowedRoles: ["dev", "presensi"],
		},
	},
	{
		path: "/pengguna",
		name: "pengguna",
		component: PenggunaView,
		meta: {
			type: "menu",
			icon: "bi bi-person-lines-fill",
			menuTitle: "Pengguna Presensi",
			page: {
				tab: `Pengguna Presensi · ${appTitle}`,
				header: "Data Pengguna Presensi",
				label: "Pengguna Presensi",
			},
			allowedTypes: ["admin", "guru", "karyawan"],
			allowedRoles: ["dev", "presensi"],
		},
		children: [
			{
				path: "guru",
				name: "pengguna-guru",
				component: UserGuru,
				meta: {
					type: "page",
					activeMenu: "/pengguna",
					page: {
						tab: `Pengguna Presensi · Guru · ${appTitle}`,
						header: "Data Pengguna Presensi · Guru",
						label: "Guru",
					},
					allowedTypes: ["admin", "guru", "karyawan"],
					allowedRoles: ["dev", "presensi"],
				},
			},
			{
				path: "karyawan",
				name: "pengguna-karyawan",
				component: UserKaryawan,
				meta: {
					type: "page",
					activeMenu: "/pengguna",
					page: {
						tab: `Pengguna Presensi · Tenaga Kependidikan · ${appTitle}`,
						header: "Data Pengguna Presensi · Tenaga Kependidikan",
						label: "Tenaga Kependidikan",
					},
					allowedTypes: ["admin", "guru", "karyawan"],
					allowedRoles: ["dev", "presensi"],
				},
			},
			{
				path: "siswa",
				name: "pengguna-siswa",
				component: UserSiswa,
				meta: {
					type: "page",
					activeMenu: "/pengguna",
					page: {
						tab: `Pengguna Presensi · Siswa · ${appTitle}`,
						header: "Data Pengguna Presensi · Siswa",
						label: "Siswa",
					},
					allowedTypes: ["admin", "guru", "karyawan"],
					allowedRoles: ["dev", "presensi"],
				},
			},
			{
				path: "non-gtk",
				name: "pengguna-non-gtk",
				component: UserNonGtk,
				meta: {
					type: "page",
					activeMenu: "/pengguna",
					page: {
						tab: `Pengguna Presensi · Non-GTK · ${appTitle}`,
						header: "Data Pengguna Presensi · Non-GTK",
						label: "Non-GTK",
					},
					allowedTypes: ["admin", "guru", "karyawan"],
					allowedRoles: ["dev", "presensi"],
				},
			},
		],
	},
	{
		path: "/izin",
		name: "izin",
		component: IzinView,
		meta: {
			type: "menu",
			icon: "bi bi-person-raised-hand",
			menuTitle: "Izin Presensi",
			page: {
				tab: `Izin Presensi · ${appTitle}`,
				header: "Data Izin Presensi",
				label: "Izin Presensi",
			},
			allowedTypes: ["admin", "guru", "karyawan"],
			allowedRoles: ["dev", "presensi", "staf"],
		},
		children: [
			{
				path: "guru",
				name: "izin-guru",
				component: IzinGuru,
				meta: {
					type: "page",
					activeMenu: "/izin",
					page: {
						tab: `Izin Presensi · Guru · ${appTitle}`,
						header: "Data Izin Presensi · Guru",
						label: "Guru",
					},
					allowedTypes: ["admin", "guru", "karyawan"],
					allowedRoles: ["dev", "presensi", "staf"],
				},
			},
			{
				path: "karyawan",
				name: "izin-karyawan",
				component: IzinKaryawan,
				meta: {
					type: "page",
					activeMenu: "/izin",
					page: {
						tab: `Izin Presensi · Tenaga Kependidikan · ${appTitle}`,
						header: "Data Izin Presensi · Tenaga Kependidikan",
						label: "Tenaga Kependidikan",
					},
					allowedTypes: ["admin", "guru", "karyawan"],
					allowedRoles: ["dev", "presensi", "staf"],
				},
			},
			{
				path: "siswa",
				name: "izin-siswa",
				component: IzinSiswa,
				meta: {
					type: "page",
					activeMenu: "/izin",
					page: {
						tab: `Izin Presensi · Siswa · ${appTitle}`,
						header: "Data Izin Presensi · Siswa",
						label: "Siswa",
					},
					allowedTypes: ["admin", "guru", "karyawan"],
					allowedRoles: ["dev", "presensi", "staf"],
				},
			},
			{
				path: "non-gtk",
				name: "izin-non-gtk",
				component: IzinNonGtk,
				meta: {
					type: "page",
					activeMenu: "/izin",
					page: {
						tab: `Izin Presensi · Non-GTK · ${appTitle}`,
						header: "Data Izin Presensi · Non-GTK",
						label: "Non-GTK",
					},
					allowedTypes: ["admin", "guru", "karyawan"],
					allowedRoles: ["dev", "presensi", "staf"],
				},
			},
		],
	},
	{
		path: "/presensi",
		name: "presensi",
		component: PresensiView,
		meta: {
			type: "menu",
			icon: "bi bi-list-check",
			menuTitle: "Data Presensi",
			page: {
				tab: `Data Presensi · ${appTitle}`,
				header: "Data Presensi",
				label: "Presensi",
			},
			allowedTypes: ["admin", "guru", "karyawan"],
			allowedRoles: ["dev", "presensi", "staf"],
		},
		children: [
			{
				path: "guru",
				name: "presensi-guru",
				component: RiwayatGuru,
				meta: {
					type: "page",
					activeMenu: "/presensi",
					page: {
						tab: `Riwayat Presensi · Guru · ${appTitle}`,
						header: "Riwayat Presensi · Guru",
						label: "Guru",
					},
					allowedTypes: ["admin", "guru", "karyawan"],
					allowedRoles: ["dev", "presensi", "staf"],
				},
			},
			{
				path: "karyawan",
				name: "presensi-karyawan",
				component: RiwayatKaryawan,
				meta: {
					type: "page",
					activeMenu: "/presensi",
					page: {
						tab: `Riwayat Presensi · Tenaga Kependidikan · ${appTitle}`,
						header: "Riwayat Presensi · Tenaga Kependidikan",
						label: "Tenaga Kependidikan",
					},
					allowedTypes: ["admin", "guru", "karyawan"],
					allowedRoles: ["dev", "presensi", "staf"],
				},
			},
			{
				path: "siswa",
				name: "presensi-siswa",
				component: RiwayatSiswa,
				meta: {
					type: "page",
					activeMenu: "/presensi",
					page: {
						tab: `Riwayat Presensi · Siswa · ${appTitle}`,
						header: "Riwayat Presensi · Siswa",
						label: "Siswa",
					},
					allowedTypes: ["admin", "guru", "karyawan"],
					allowedRoles: ["dev", "presensi", "staf"],
				},
			},
			{
				path: "non-gtk",
				name: "presensi-non-gtk",
				component: RiwayatNonGtk,
				meta: {
					type: "page",
					activeMenu: "/presensi",
					page: {
						tab: `Riwayat Presensi · Non-GTK · ${appTitle}`,
						header: "Riwayat Presensi · Non-GTK",
						label: "Non-GTK",
					},
					allowedTypes: ["admin", "guru", "karyawan"],
					allowedRoles: ["dev", "presensi", "staf"],
				},
			},
			{
				path: "rekap",
				name: "presensi-rekap",
				component: RekapPresensi,
				meta: {
					type: "page",
					activeMenu: "/presensi",
					page: {
						tab: `Rekapitulasi Presensi · ${appTitle}`,
						header: "Rekapitulasi Presensi",
						label: "Rekapitulasi",
					},
					allowedTypes: ["admin", "guru", "karyawan"],
					allowedRoles: ["dev", "presensi", "staf"],
				},
			},
		],
	},
	{
		path: "/profil",
		name: "profil",
		component: ProfileView,
		meta: {
			type: "page",
			page: {
				tab: `Pengaturan Pengguna · ${appTitle}`,
				header: "Pengaturan Pengguna",
				label: "Pengaturan Pengguna",
			},
			allowedTypes: ["admin", "guru", "karyawan", "siswa"],
		},
	},
	{
		path: "/forbidden/:halaman(.*)?",
		name: "forbidden",
		component: ForbiddenView,
		meta: {
			page: {
				tab: `Akses Tidak Diizinkan · ${appTitle}`,
			},
		},
	},
	{
		path: "/:catchAll(.*)",
		name: "not-found",
		component: NotFound,
		meta: {
			page: {
				tab: `Halaman Tidak Ditemukan · ${appTitle}`,
			},
		},
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

router.beforeEach((to, from, next) => {
	const user = store.getters.getUser;
	const roles = store.getters.getRoles;

	const { allowedTypes = [], allowedRoles = [] } = to.meta;

	const isAllowedType = !allowedTypes.length || allowedTypes.includes(user?.type);
	const isAllowedRole = !allowedRoles.length || roles?.some((r) => allowedRoles.includes(r.role)) || allowedRoles.includes(user?.type);

	if (!isAllowedType || !isAllowedRole) {
		return next("/forbidden/" + to.meta.title);
	}

	next();
});

export default router;
